(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gran-invento-home-episodes"]) return;
  try {
    
  document.querySelectorAll('[data-episode-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('.gi-home-favorites__track');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const section = carousel.closest('.gi-home-favorites');
    const previous = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    const status = section.querySelector('[data-carousel-status]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer;

    const render = () => {
      track.style.transform = `translateX(-${current * 100}%)`;
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === current ? 'false' : 'true');
        slide.querySelector('a').tabIndex = index === current ? 0 : -1;
      });
      status.textContent = `${current + 1} / ${slides.length}`;
    };

    const move = (direction) => {
      current = (current + direction + slides.length) % slides.length;
      render();
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!reduceMotion && slides.length > 1) timer = window.setInterval(() => move(1), 5500);
    };

    previous.addEventListener('click', () => { move(-1); start(); });
    next.addEventListener('click', () => { move(1); start(); });
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    render();
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gran-invento-live"]) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.gi-live');
    roots.forEach(function (root) {
      var byteField = root.querySelector('[data-byte-field]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (byteField && !reduceMotion && !byteField.children.length) {
        var glyphs = ['0', '1', '01', '10', '001', '110', '◆', '·'];
        for (var i = 0; i < 30; i += 1) {
          var bit = document.createElement('span');
          bit.className = 'gi-byte';
          bit.textContent = glyphs[Math.floor(Math.random() * glyphs.length)];
          bit.style.setProperty('--left', (Math.random() * 100) + '%');
          bit.style.setProperty('--duration', (7 + Math.random() * 9) + 's');
          bit.style.setProperty('--size', (8 + Math.random() * 7) + 'px');
          bit.style.setProperty('--opacity', (.12 + Math.random() * .3));
          bit.style.setProperty('--drift', (-100 + Math.random() * 200) + 'px');
          bit.style.animationDelay = (-Math.random() * 14) + 's';
          byteField.appendChild(bit);
        }
      }
      var title = root.querySelector('[data-inspector-title]');
      var copy = root.querySelector('[data-inspector-copy]');
      var resultLink = root.querySelector('[data-inspector-link]');
      var newsForm = root.querySelector('[data-news-form]');
      var newsInput = root.querySelector('[data-news-url]');
      var newsButton = newsForm ? newsForm.querySelector('button[type="submit"]') : null;
      var newsStatus = root.querySelector('[data-news-status]');
      var newsQueue = root.querySelector('[data-news-queue]');
      var queueCount = root.querySelector('[data-queue-count]');
      var queueEmpty = root.querySelector('[data-queue-empty]');
      var submittedNews = 0;
      var invalidMessage = newsForm ? newsForm.getAttribute('data-invalid-message') : '';
      var processingMessage = newsForm ? newsForm.getAttribute('data-processing-message') : '';
      var completeMessage = newsForm ? newsForm.getAttribute('data-complete-message') : '';
      var newsErrorMessage = newsForm ? newsForm.getAttribute('data-error-message') : '';
      var evaluationLabel = newsForm ? newsForm.getAttribute('data-evaluation-label') : '';
      var itemSingular = newsForm ? newsForm.getAttribute('data-item-singular') : '';
      var itemPlural = newsForm ? newsForm.getAttribute('data-item-plural') : '';

      function titleFromUrl(url) {
        var segment = url.pathname.split('/').filter(Boolean).pop() || url.hostname;
        var clean = decodeURIComponent(segment).replace(/\.[a-z0-9]{2,5}$/i, '').replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
        return clean ? clean.charAt(0).toUpperCase() + clean.slice(1) : url.hostname;
      }

      function addNewsCard(url, detectedTitle, publicStatus, sourceName) {
        var card = document.createElement('article');
        var headline = document.createElement('strong');
        var source = document.createElement('span');
        var state = document.createElement('small');
        card.className = 'gi-news-card';
        headline.textContent = detectedTitle;
        source.textContent = sourceName || url.hostname;
        state.textContent = publicStatus || evaluationLabel;
        card.appendChild(headline);
        card.appendChild(source);
        card.appendChild(state);
        if (queueEmpty) queueEmpty.hidden = true;
        newsQueue.prepend(card);
        submittedNews += 1;
        queueCount.textContent = submittedNews + ' ' + (submittedNews === 1 ? itemSingular : itemPlural);
      }

      function animateAbsorption(parsed, startBox, targetBox, done) {
        var rootBox = root.getBoundingClientRect();
        var startX = startBox.left + startBox.width / 2 - rootBox.left;
        var startY = startBox.top + startBox.height / 2 - rootBox.top;
        var endX = targetBox.left + targetBox.width / 2 - rootBox.left;
        var endY = targetBox.top + targetBox.height / 2 - rootBox.top;
        var deltaX = endX - startX;
        var deltaY = endY - startY;
        var target = root.querySelector('[data-intelligence-node]');
        var glyphs = ['0', '1', '01', '10', '◆'];

        root.classList.add('is-ingesting');
        target.classList.add('is-absorbing');

        for (var p = 0; p < 34; p += 1) {
          var particle = document.createElement('span');
          var isBit = p % 4 === 0;
          var spread = (Math.random() - .5) * 150;
          var lift = -55 - Math.random() * 105;
          var spiral = (Math.random() - .5) * 90;
          particle.className = 'gi-absorb-particle' + (isBit ? ' gi-absorb-particle--bit' : '');
          if (isBit) particle.textContent = glyphs[Math.floor(Math.random() * glyphs.length)];
          particle.style.setProperty('--particle-left', startX + 'px');
          particle.style.setProperty('--particle-top', startY + 'px');
          particle.style.setProperty('--particle-size', (2 + Math.random() * 4) + 'px');
          particle.style.setProperty('--particle-color', p % 3 === 0 ? 'var(--cyan)' : 'var(--green)');
          root.appendChild(particle);
          particle.animate([
            { opacity: 0, transform: 'translate3d(0,0,0) scale(.3)' },
            { opacity: 1, transform: 'translate3d(' + (spread * .25) + 'px,' + (lift * .35) + 'px,0) scale(1)', offset: .16 },
            { opacity: .92, transform: 'translate3d(' + (deltaX * .58 + spread) + 'px,' + (deltaY * .58 + lift) + 'px,0) rotate(' + spiral + 'deg)', offset: .62 },
            { opacity: 1, transform: 'translate3d(' + (deltaX + spiral) + 'px,' + (deltaY - Math.abs(spiral) * .35) + 'px,0) scale(.65)', offset: .84 },
            { opacity: 0, transform: 'translate3d(' + deltaX + 'px,' + deltaY + 'px,0) scale(0)' }
          ], {
            duration: 1250 + Math.random() * 550,
            delay: Math.random() * 180,
            easing: 'cubic-bezier(.18,.72,.22,1)',
            fill: 'forwards'
          }).finished.then((function (element) {
            return function () { element.remove(); };
          }(particle)));
        }

        var packet = document.createElement('span');
        packet.className = 'gi-news-packet';
        packet.textContent = 'ABSORBING · ' + parsed.hostname;
        packet.style.setProperty('--packet-left', (startX - 74) + 'px');
        packet.style.setProperty('--packet-top', (startY - 17) + 'px');
        packet.style.animation = 'none';
        root.appendChild(packet);
        packet.animate([
          { opacity: 0, transform: 'translate3d(0,0,0) scaleX(.45)' },
          { opacity: 1, transform: 'translate3d(0,-12px,0) scaleX(1)', offset: .14 },
          { opacity: 1, transform: 'translate3d(' + (deltaX * .48) + 'px,' + (deltaY * .48 - 42) + 'px,0) scale(.88)', offset: .55 },
          { opacity: .9, transform: 'translate3d(' + (deltaX * .82) + 'px,' + (deltaY * .82 + 18) + 'px,0) scaleX(.32)', offset: .78 },
          { opacity: 0, transform: 'translate3d(' + deltaX + 'px,' + deltaY + 'px,0) scale(0)' }
        ], { duration: 1550, easing: 'cubic-bezier(.18,.72,.18,1)', fill: 'forwards' }).finished.then(function () { packet.remove(); });

        window.setTimeout(function () {
          root.classList.remove('is-ingesting');
          target.classList.remove('is-absorbing');
          done();
        }, 1800);
      }

      if (newsForm) {
        newsForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var parsed;
          try {
            parsed = new URL(newsInput.value.trim());
            if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') throw new Error('protocol');
          } catch (error) {
            newsStatus.className = 'gi-intake__status is-error';
            newsStatus.textContent = invalidMessage;
            newsInput.focus();
            return;
          }

          var detectedTitle = titleFromUrl(parsed);
          var target = root.querySelector('[data-intelligence-node]');
          var startBox = newsInput.getBoundingClientRect();
          var targetBox = target.getBoundingClientRect();
          newsStatus.className = 'gi-intake__status is-active';
          newsStatus.textContent = processingMessage;
          newsButton.disabled = true;

          var finishIntake = function () {
            var newsEndpoint = root.getAttribute('data-news-endpoint');
            fetch(newsEndpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ url: parsed.href, source: 'graninvento-live' })
            })
              .then(function (response) {
                return response.json().then(function (payload) {
                  if (!response.ok) {
                    var requestError = new Error(payload.message || newsErrorMessage);
                    requestError.payload = payload;
                    throw requestError;
                  }
                  return payload;
                });
              })
              .then(function (payload) {
                addNewsCard(parsed, payload.title || detectedTitle, payload.public_status, payload.source);
                newsStatus.className = 'gi-intake__status is-active';
                newsStatus.textContent = payload.duplicate ? payload.public_status : completeMessage;
                newsInput.value = '';
              })
              .catch(function (error) {
                newsStatus.className = 'gi-intake__status is-error';
                newsStatus.textContent = error.message;
              })
              .then(function () { newsButton.disabled = false; });
          };
          if (reduceMotion) finishIntake();
          else animateAbsorption(parsed, startBox, targetBox, finishIntake);
        });
      }
      root.querySelectorAll('[data-node]').forEach(function (node) {
        node.addEventListener('click', function () {
          root.querySelectorAll('[data-node]').forEach(function (item) { item.setAttribute('aria-expanded', 'false'); });
          node.setAttribute('aria-expanded', 'true');
          title.textContent = node.querySelector('strong').textContent;
          copy.textContent = node.querySelector('small').textContent;
          if (node.getAttribute('data-result-url')) {
            resultLink.href = node.getAttribute('data-result-url');
            resultLink.hidden = false;
          } else {
            resultLink.hidden = true;
            resultLink.removeAttribute('href');
          }
        });
      });

      var endpoint = root.getAttribute('data-endpoint');
      var cacheKey = 'gran-invento-live-state-v1';
      var currentActivity = root.querySelector('[data-live-current]');
      var updatedLabel = root.querySelector('[data-live-updated]');
      var loadingMessage = root.getAttribute('data-loading-message');
      var wakingMessage = root.getAttribute('data-waking-message');
      var liveMessage = root.getAttribute('data-live-message');
      var offlineMessage = root.getAttribute('data-offline-message');
      var nextEpisodeTemplate = root.getAttribute('data-next-episode-template');
      var radarMessageTemplates = [
        root.getAttribute('data-radar-message-one'),
        root.getAttribute('data-radar-message-two'),
        root.getAttribute('data-radar-message-three')
      ];
      var buildingMessage = root.getAttribute('data-building-message');
      var supervisingMessage = root.getAttribute('data-supervising-message');
      var nextActivity = root.querySelector('[data-live-next-activity]');
      var radarTimer;
      var statsEndpoint = root.getAttribute('data-stats-endpoint');
      var statsUpdated = root.querySelector('[data-stats-updated]');
      var englishPublicUrl = root.getAttribute('data-english-public-url');
      var retryDelays = [5000, 15000, 30000, 60000];
      var retryIndex = 0;

      function animateStat(element, value) {
        var target = Number(value);
        if (!Number.isFinite(target)) return;
        element.setAttribute('data-stat-value', target);
        if (reduceMotion) {
          element.textContent = new Intl.NumberFormat().format(target);
          return;
        }
        var startedAt;
        var frame = function (time) {
          if (!startedAt) startedAt = time;
          var progress = Math.min((time - startedAt) / 900, 1);
          element.textContent = new Intl.NumberFormat().format(Math.round(target * (1 - Math.pow(1 - progress, 3))));
          if (progress < 1) window.requestAnimationFrame(frame);
        };
        window.requestAnimationFrame(frame);
      }

      root.querySelectorAll('[data-stat-value]').forEach(function (stat) { animateStat(stat, stat.getAttribute('data-stat-value')); });

      function fetchStats() {
        if (!statsEndpoint) return;
        fetch(statsEndpoint, { headers: { Accept: 'application/json' } })
          .then(function (response) { if (!response.ok) throw new Error('status'); return response.json(); })
          .then(function (data) {
            if (!Array.isArray(data.metrics)) return;
            data.metrics.forEach(function (metric) {
              var element = root.querySelector('[data-stat-key="' + metric.key + '"]');
              if (!element) return;
              if (metric.formatted_value) element.textContent = metric.formatted_value;
              else animateStat(element, metric.value);
            });
            if (data.updated_at) statsUpdated.textContent = new Date(data.updated_at).toLocaleString();
          })
          .catch(function () {});
      }

      function updateNextActivity(data) {
        var nextNumber = Number(data.episode) + 1;
        window.clearInterval(radarTimer);
        if (data.status === 'running') {
          nextActivity.textContent = buildingMessage + ' · ' + (data.current_activity || '');
          return;
        }
        if (data.status === 'failed' || data.status === 'stalled' || data.status === 'completed_with_errors') {
          nextActivity.textContent = supervisingMessage;
          return;
        }
        var radarIndex = 0;
        var showRadarMessage = function () {
          nextActivity.textContent = radarMessageTemplates[radarIndex].replace('__NUMBER__', nextNumber);
          radarIndex = (radarIndex + 1) % radarMessageTemplates.length;
        };
        showRadarMessage();
        if (!reduceMotion) radarTimer = window.setInterval(showRadarMessage, 6500);
      }

      function renderState(data, cached) {
        if (!data || !Array.isArray(data.steps)) return;
        root.classList.remove('is-offline');
        root.classList.add('is-live');
        if (data.episode) {
          root.querySelector('[data-live-episode]').textContent = 'EPISODE #' + data.episode;
          root.querySelector('[data-live-next-episode]').textContent = nextEpisodeTemplate.replace('__NUMBER__', Number(data.episode) + 1);
        }
        updateNextActivity(data);
        if (data.current_activity) currentActivity.textContent = data.current_activity;
        if (typeof data.progress === 'number') root.querySelector('[data-live-progress]').style.width = data.progress + '%';
        var updatedAt = new Date(data.updated_at);
        var updatedSuffix = Number.isNaN(updatedAt.getTime()) ? '' : ' · ' + updatedAt.toLocaleString();
        updatedLabel.textContent = cached ? loadingMessage : liveMessage + updatedSuffix;
        data.steps.forEach(function (step) {
          var node = root.querySelector('[data-step-key="' + step.key + '"]');
          if (!node) return;
          node.classList.remove('is-completed', 'is-running', 'is-pending', 'is-manual', 'is-failed', 'is-skipped');
          var stateClass = step.status === 'manual_required' ? 'is-manual' : 'is-' + step.status;
          node.classList.add(stateClass);
          node.querySelector('strong').textContent = step.label;
          node.querySelector('small').textContent = step.message;
          var publicResultUrl = step.key === 'english_episode' && englishPublicUrl ? englishPublicUrl : step.url;
          if (publicResultUrl) node.setAttribute('data-result-url', publicResultUrl);
          else node.removeAttribute('data-result-url');
          if (typeof step.completed === 'number' && typeof step.total === 'number') {
            var icon = node.querySelector('.gi-node__icon');
            if (icon) icon.textContent = step.completed + '/' + step.total;
          }
        });
      }

      function fetchState() {
        var controller = new AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 70000);
        if (!root.classList.contains('is-live')) updatedLabel.textContent = wakingMessage;
        fetch(endpoint, { headers: { Accept: 'application/json' }, signal: controller.signal })
          .then(function (response) { if (!response.ok) throw new Error('status'); return response.json(); })
          .then(function (data) {
            window.clearTimeout(timeout);
            retryIndex = 0;
            try { localStorage.setItem(cacheKey, JSON.stringify(data)); } catch (storageError) { /* Live data still renders. */ }
            renderState(data, false);
            window.setTimeout(fetchState, 30000);
          })
          .catch(function () {
            window.clearTimeout(timeout);
            if (retryIndex < retryDelays.length) {
              window.setTimeout(fetchState, retryDelays[retryIndex]);
              retryIndex += 1;
            } else {
              root.classList.add('is-offline');
              root.classList.remove('is-live');
              updatedLabel.textContent = offlineMessage;
            }
          });
      }

      if (!endpoint) return;
      try {
        var cachedState = JSON.parse(localStorage.getItem(cacheKey));
        if (cachedState) renderState(cachedState, true);
      } catch (cacheError) {
        try { localStorage.removeItem(cacheKey); } catch (storageError) { /* Storage can be unavailable. */ }
      }
      fetchState();
      fetchStats();
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
